import { AiGenerateButton } from '../../../../../../widgets/ai';
import { Button, Link } from '../../../../../../widgets/buttons';
import React from 'react';
import Sparkles from 'src/components/widgets/svg/sparkles';
import { T } from 'src/shared/helpers';
import PlusIcon from 'src/shared/material_icons/content/add.svg';
import styled from 'styled-components';
const ComposerStartedTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
    text-align: center;
`;

const ComposerStartedDescription = styled.p`
    text-align: center;
    margin-bottom: 2rem;
    max-width: 600px;
    line-height: 1.5;
`;

const ComposerStartedButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
`;

const AttributesButton = styled(Button)`
    color: #fff;
    gap: 0.5rem;
`;

const ComposerStartedContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
    padding: 8em;
    justify-content: start;
`;

const ComposerStarted: React.FC<{ onAddAttributes: () => void; onGenerateAttributesWithAI: () => void }> = ({
    onAddAttributes,
    onGenerateAttributesWithAI
}) => {
    return (
        <ComposerStartedContainer>
            <ComposerStartedTitle>{T._('Customization options', 'Admin')}</ComposerStartedTitle>
            <ComposerStartedDescription>
                {T._('This is where you create attributes and options for your product', 'Admin')}{' '}
                <Link target='_blank' href='https://zakeke.zendesk.com/hc/en-us/articles/360009576134-Composer'>
                    {T._('see guidelines', 'Admin')}
                </Link>
                . {T._('If you prefer, you can also use our', 'Admin')}{' '}
                <Link target='_blank' href='https://zakeke.zendesk.com/hc/en-us/articles/14248769413532-Generate-Attributes-and-Options-with-AI'>
                    {T._('AI to assist you', 'Admin')}
                </Link>{' '}
                in the process.
            </ComposerStartedDescription>
            <ComposerStartedButtonContainer>
                <AttributesButton $size='large' onClick={onAddAttributes}>
                    <PlusIcon fill='white' />
                    {T._('Add attributes', 'Admin')}
                </AttributesButton>
                <AiGenerateButton type='button' $size='large' onClick={onGenerateAttributesWithAI}>
                    <Sparkles />
                    {T._('Generate attributes with AI', 'Admin')}
                </AiGenerateButton>
            </ComposerStartedButtonContainer>
        </ComposerStartedContainer>
    );
};

export default ComposerStarted;
